<template>
  <div>
    <monitor-video
      stoppable
      :icon-color="color"
      :color="color"
      :urls="urls"
      :progress-percent="progress_percent"
      :show-player="show_player"
      :progress-warning="is_near_to_end"
      :player-text="player_text"
      :edit="true"
      edit-text="Edit event"
      @close="close"
      @edit="open_editor"
    >
      <template v-slot:title>
        {{name}}
      </template>
      <template v-slot:subtitle>
        {{time}}
      </template>
      <template v-slot:stop>
        <stop-event :uuid="data.uuid">
          <k-btn style="height: 15px; margin:0px; padding:0px;" size="m" icon color="danger" icon-name="stop"></k-btn>
        </stop-event>
      </template>

    </monitor-video>
  </div>
</template>

<script>
import datelib from '@/lib/date.js';
import moment from 'moment';
import Mustache from 'mustache'
import EventModel from '@/models/event.js'
import MonitorVideo from '@/components/MonitorVideo.vue';
import StopEvent from '@/components/StopEvent.vue';

export default {
  props: ['data', 'timestamp'],
  components: {
    MonitorVideo,
    StopEvent
  },
  data() {
    return {
    }
  },
  computed: {
    player_text() {
      if (this.is_past) return "Event has ended";
      if (this.is_running) return "No preview";
      if (this.is_future) return "Event has not yet started";
      return "No preview";
    },
    show_player() {
      return this.is_running || this.is_future;
    },
    color() {
      if (this.is_running) return "success";
      if (this.is_future) return "info";
      if (this.is_past) return "past"
      return "primary";
    },
    progress_percent() {
      return EventModel.progress_percent(this.data, this.timestamp);
    },
    urls () {
      return [
        {title: "Preview", url: EventModel.preview_url(this.data)},
        {title: "Live", url: EventModel.live_url(this.data)}
      ]
    },
    is_past() {
      return EventModel.is_past(this.data, this.timestamp);
    },
    is_running() {
      return EventModel.is_current(this.data, this.timestamp);
    },
    is_near_to_end() {
      return EventModel.is_near_to_end(this.data, this.timestamp);
    },
    is_future() {
      return EventModel.is_future(this.data, this.timestamp);
    },
    preview_url() {
      return EventModel.preview_url(this.data);
    },
    name() {
      return EventModel.title(this.data);
    },
    time() {
      return this.format_date(this.data.cached_start_time)
    }
  },
  methods: {
    format_date (v) {
      return datelib.format_date(v) + " - " + datelib.format_time(v);
    },
    open_editor() {
      this.$router.push("/multiview/event/"+this.data.uuid)
    },
    close() {
      if (!this.$store.state.account) return;
      var acc = _.cloneDeep(this.$store.state.account);
      acc.meta.multiview_event_filter = _.xor(acc.meta.multiview_event_filter, [this.data.uuid]);
      this.$store.dispatch("update_profile", acc);
    }
  }
}
</script>
